const links = {
  whatsapp: {
    community: "https://chat.whatsapp.com/HGieM3eSuWrF0tIb8WG7yR",
  },
  telegram: {
    bot: "https://t.me/nibebebot",
  },
  slack: {
    bot: "https://api.nibebe.app/slack/login",
  },
  facebook: {
    bot: "https://m.me/nibebe.app",
    page: "https://www.facebook.com/nibebe.app",
  },
  playstore:
    "https://play.google.com/store/apps/details?id=com.hudumabomba.safari&gl=US",
  appstore: "https://apps.apple.com/us/app/nibebe-share-a-ride/id1567671939",
  integrations: () => [
    {
      name: (
        <img
          src="https://img.icons8.com/color/48/null/whatsapp--v1.png"
          alt="Whatsapp"
          height={96}
        />
      ),
      link: links.whatsapp.community,
    },
    {
      name: (
        <img
          src="https://img.icons8.com/color/48/null/telegram-app--v1.png"
          alt="Telegram"
          height={96}
        />
      ),
      link: links.telegram.bot,
    },
    {
      name: (
        <img
          src="https://img.icons8.com/color/48/null/slack--v1.png"
          alt="Slack"
          height={96}
        />
      ),
      link: links.slack.bot,
    },
    {
      name: (
        <img
          src="https://img.icons8.com/ios/48/null/facebook-messenger--v1.png"
          alt="Messenger"
          height={96}
        />
      ),
      link: links.facebook.bot,
    },
  ],
};
export default links;
